import { gql } from '@apollo/client'

const GUEST_QUERY = gql`
  query SimplifiedGuestQuery {
    shouldSeePuppyDiscountModal: featureFlag(
      flag: "should_see_puppy_discount_modal"
      fallback: "not_in_cohort"
    )
    shouldSeePlansMultivariateTest: featureFlag(
      flag: "should_see_plans_multivariate_test"
      fallback: "not_in_cohort"
    )
    currentUser {
      __typename
      ... on Guest {
        id
        numberOfAffiliateFreeBoxes
        preferredLanguage
        assumedShippingCountry {
          id
          code
          showExtras
          trustpilotBusinessUnitId
        }
        dogs {
          id
          name
          gender
          previousFoodTypes {
            foodItem
          }
        }
        discountCode {
          id
          discountCodeParts {
            n
            discountType
            discountBasis
            value
          }
        }
      }
    }
  }
`

export default GUEST_QUERY
